import { postServerRequest, patchServerRequest, getServerRequest, deleteServerRequest } from '@/helpers/serverRequest.helper';
import { store } from '@/store/store';

const httpURL = store.getters.httpURL;

export const cargarOficiosDeparaService = async (data) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/oficios/depara`;
    return await postServerRequest(url, data, config);
}

export const crearOficioDeparaService = async (formData) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token, 'Content-Type': 'multipart/form-data' } };
    const url = `${httpURL}/oficios/depara/crear`;
    return await postServerRequest(url, formData, config);
}

export const modificarOficioDeparaService = async (data) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/oficios/depara/${data.idDepara}`;
    return await patchServerRequest(url, data, config);
}

export const cargarDeparaByIdService = async (idDepara) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/oficios/depara/${idDepara}`;
    return await getServerRequest(url, config);
}

export const eliminarDeparaService = async (idDepara) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/oficios/depara/eliminar/${idDepara}`;
    return await deleteServerRequest(url, config);
}

